import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export const AddCoveragesButton = ({ onClick, ...props }) => {
  return (
    <Button type='primary' icon={<PlusOutlined />} onClick={onClick} {...props}>
      Añadir coberturas
    </Button>
  );
};